import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import MenusDataGrid from '../menus-data-grid/menus-data-grid.component';
import { useMenusSearch } from '../menus-landing.hooks';
import { Box } from '@mui/material';
import BulkEditDataGridProvider from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';

const MenusImported = () => {
  const search = useMenusSearch();

  return (
    <Box mt={2}>
      <SearchProvider value={search}>
        <SearchToolbar />
        <BulkEditDataGridProvider>
          <MenusDataGrid />
        </BulkEditDataGridProvider>
      </SearchProvider>
    </Box>
  );
};

export default MenusImported;
